import apiClient from './client';
import { API_ENDPOINTS } from '@/constants';

export const authApi = {
  login: (credentials) => apiClient.post(API_ENDPOINTS.AUTH.LOGIN, credentials),
  logout: () => apiClient.post(API_ENDPOINTS.AUTH.LOGOUT),
  refresh: () => apiClient.post(API_ENDPOINTS.AUTH.REFRESH),
  getMe: () => apiClient.get(API_ENDPOINTS.AUTH.ME),
  changePassword: (data) => apiClient.post(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, data),
  forgotPassword: (email) => apiClient.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email }),
  resetPassword: (data) => apiClient.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, data),
  updateProfile: (data) => apiClient.patch(API_ENDPOINTS.AUTH.PROFILE, data),
  updatePreferences: (data) => apiClient.patch(API_ENDPOINTS.AUTH.PREFERENCES, data),
  getLoginHistory: () => apiClient.get(API_ENDPOINTS.AUTH.LOGIN_HISTORY),
  getSessions: () => apiClient.get(API_ENDPOINTS.AUTH.SESSIONS),
  logoutAll: () => apiClient.post(API_ENDPOINTS.AUTH.LOGOUT_ALL),
  getSecurity: () => apiClient.get(API_ENDPOINTS.AUTH.SECURITY),
  uploadAvatar: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post(API_ENDPOINTS.AUTH.UPLOAD_AVATAR, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  createUser: (data) => apiClient.post(API_ENDPOINTS.USERS.BASE, data),
};
